import type { RadioTextFilterValue } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';
import { getLabels as radioTextLabelFormatterGetLabels } from './GenericLabelFormatter/RadioTextLabelFormatter';

export function getLabels(
  currentValue: RadioTextFilterValue | undefined,
  filterKind: FilterKindEnum,
): LabelProps {
  return radioTextLabelFormatterGetLabels(currentValue, filterKind);
}
